/**
 * Types of display fields
 *
 * - List view
 * - Detail view
 * - Edit View
 */
export var FieldViewType;
(function (FieldViewType) {
    FieldViewType["DETAIL"] = "detail";
    FieldViewType["EDIT"] = "edit";
    FieldViewType["LIST"] = "list";
})(FieldViewType || (FieldViewType = {}));
export var screenViewType;
(function (screenViewType) {
    screenViewType["DETAILVIEW"] = "detailview";
    screenViewType["EDITVIEW"] = "editview";
    screenViewType["LISTVIEW"] = "listview";
})(screenViewType || (screenViewType = {}));
